const entityType = {
  researcher: 'Researcher',
  organisation: 'Organisation',
};

export default entityType;
